import { Fill, Stroke, Style } from "ol/style";

export const GbCensusDefaultStyle = new Style({
  fill: new Fill({ color: "rgba(0, 123, 255, 0.2)" }),
  stroke: new Stroke({ color: "rgb(255, 115, 0)", width: 0.8 }),
});

export const GbCensusSelectedStyle = new Style({
  fill: new Fill({ color: "rgba(255, 115, 0, 0.25)" }),
  stroke: new Stroke({ color: "rgb(255, 115, 0)", width: 2 }),
});
